import { IClassroom } from "../../classrooms";
import { EntityTypes } from "../../EntityTypes";
import { IUser } from "../../users";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { FactoryType, IFactory } from "../types";

export type IFactoryCreateMutationParameters = {
    classrooms: RelationalValue<IClassroom>[];
    managers: RelationalValue<IUser>[];
    trainers: RelationalValue<IUser>[];
    uuid?: string;
    type: FactoryType;
};

export type IFactoryCreateMutationResult = IFactory;

export const factoryCreateMutation: IApiMutationFunction<IFactoryCreateMutationParameters> = ({
    classrooms,
    managers,
    trainers,
    type,
}) => {
    return {
        method: "POST",
        url: "/factories",
        data: {
            classrooms: classrooms.map(classroom => mapRelationalValueAsIRI(EntityTypes.CLASSROOM, classroom)),
            managers: managers.map(manager => mapRelationalValueAsIRI(EntityTypes.USER, manager)),
            trainers: trainers.map(trainer => mapRelationalValueAsIRI(EntityTypes.USER, trainer)),
            type,
        },
    };
};

export const useFactoryCreateMutation = createApiMutationHook<
    IFactoryCreateMutationParameters,
    IFactoryCreateMutationResult
>(factoryCreateMutation);
